export default "__VITE_ASSET__BHKvPTEX__"